<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="user__list-offer">

        <!--//components-->
        <MessageDetail/>
        <!--//components-->

      </div>
    </container>
  </div>
</template>

<script>
import SubpageNav from '@/components/SubpageNav'
import MessageDetail from '@/components/MessageDetail'

export default {
  name: 'DormUserMessageDetail',
  components: {
    SubpageNav, MessageDetail
  },
  data () {
    return {
      links: [
        {
          id: 0,
          title: 'Statistics',
          to: '/yurtlar-statistics'
        },
        {
          id: 1,
          title: 'Information',
          to: '/yurt-hesap-bilgileri'
        },
        {
          id: 2,
          title: 'Reservations',
          to: '/kullanici-teklifler'
        },
        {
          id: 3,
          title: 'Messages',
          to: '/message-list'
        },
        {
          id: 4,
          title: 'My Content',
          to: '/yurt-sube'
        },
        {
          id: 5,
          title: 'My Ads',
          to: '/user-favorites'
        },
        {
          id: 6,
          title: 'Comments',
          to: '/yurtlar-comments'
        }
      ]
    }
  }
}
</script>

<style lang="scss">

</style>
